/**
 * @Directory_Path  :   public/scripts/game/content/levelTest/BlocklyManager.js:8
 * @Description     :   LevelTest Blockly Manager
 * @History_Log     :
 *                      (2018. 5. 9.) - Prototype
 *
 * @Author          : Creative_June
 */

import Interpreter from './game/lcPlugIn/interpreter/dev/frame/IP_Interpreter';

const BLOCK_ORDER = [
	'move',
	'action',
	'read',
	'change',
	'variableChange',
	'putItem',
	'loop',
	'logic',
	'if',
	'variable',
	'variables',
]
const ACTION_COLOR = '#e61b58'
const VARIABLE_COLOR = '#018b7e';
const BLOCK_IMG_SIZE = 20

export default {
    /**
     * [Data]
     *
     * @DES :: BlocklyManager Data
     * */
    interpreter : undefined,
	resizeEventHandler: undefined,
	heroId : 'hero',
	enableZoom : {
		controls: true,
		wheel: true,
		startScale: 1.2,
		maxScale: 1.8,
		minScale: 0.8,
		scaleSpeed: 1.2
	},
	disableZoom : {
    	startScale: 1.2
	},
	loadBlockIdle: undefined,
	startBlock: 'when_press_start_button',
	whenBlocks: [],
	kybrdBlck: [],

	ifBlockMake (bk) {
		let blockObject = {
			'type': bk.name,
			'previousStatement': null,
			'nextStatement': null,
			'colour': '#009ff2'
		}
		let replaceOrder = 1
		let message0 = `만약 앞에 %${replaceOrder++} 있다면`

		if (bk.isImg === true) {
			blockObject.args0 = [
				{
					'type': 'field_image',
					'src': bk.text,//.replace('https://s3.ap-northeast-2.amazonaws.com', '/codmos/static/assets'),
					'width': BLOCK_IMG_SIZE,
					'height': BLOCK_IMG_SIZE
				},
				{
					'type': 'input_dummy'
				},
				{
					'type': 'input_statement',
					'name': 'IF'
				}
			]
			message0 += ` %${replaceOrder++} %${replaceOrder++}`
		} else {
			blockObject.args0 = [
				{
					'type': 'input_dummy'
				},
				{
					'type': 'input_statement',
					'name': 'IF'
				}
			]
			message0 = message0.replace('%1', bk.text)
			replaceOrder--
			message0 += ` %${replaceOrder++} %${replaceOrder++}`
		}

		if (bk.else === true) {
			blockObject.args0.push({ 'type': 'input_dummy' })
			blockObject.args0.push({
				'type': 'input_statement',
				'name': 'ELSE'
			})
			message0 += ` 아니면 %${replaceOrder++} %${replaceOrder++}`
		}

		blockObject.message0 = message0

		Blockly.Blocks[bk.name] = {
			init: function () {
				this.jsonInit(blockObject)
			}
		}

		Blockly.JavaScript[bk.name] = function (block) {
			const IF = Blockly.JavaScript.statementToCode(block, 'IF')
			let code = ''
			code += 'if(' + 'hero' + '.' + 'checkFrontResource(\'' + bk.res + '\')' + ') {\n'
			code += IF
			code += '}'
			if (bk.else === true) {
				const ELSE = Blockly.JavaScript.statementToCode(block, 'ELSE')
				code += ' else {\n'
				code += ELSE
				code += '}'
			}
			code += '\n'

			return code
		}
	},
	createVariableBlock(bk, type, FIELD) {
		const NUM = '<value name="NUMBER"><shadow type="variable_math_variable"><field name="NUM">1</field></shadow></value>';

		const BLOCK = document.createElement('block');
		FIELD = FIELD.cloneNode(true);

		switch (type) {
			case 'getter': {
				BLOCK.setAttribute('type', 'variables_get');
				BLOCK.appendChild(FIELD);
				break;
			}
			case 'setter': {
				BLOCK.setAttribute('type', 'variables_set');
				BLOCK.appendChild(FIELD);
				BLOCK.innerHTML += NUM;
				break;
			}
			case 'plus': {
				BLOCK.setAttribute('type', 'variables_plus');
				BLOCK.appendChild(FIELD);
				BLOCK.innerHTML += NUM;
				break;
			}
			case 'minus': {
				BLOCK.setAttribute('type', 'variables_minus');
				BLOCK.appendChild(FIELD);
				BLOCK.innerHTML += NUM;
				break;
			}
			default:
		}

		return BLOCK;
	},
	/**
	 * [ Function :: initToolbox ]
	 *
	 * @DES :: toolbox 초기화
	 * @IP1 :: blocks {arr}
	 * @O.P ::
	 * @S.E ::
	 */
	initToolbox (elementId, blocks, variableBlocks = {}) {
		const TOOLBOX = document.getElementById(elementId);
		TOOLBOX.innerHTML = '';

		blocks.sort((a, b) =>
			BLOCK_ORDER.indexOf((typeof a === 'string' ? a : a.type).replace(/^en_/, '').split('_')[0])
			- BLOCK_ORDER.indexOf((typeof b === 'string' ? b : b.type).replace(/^en_/, '').split('_')[0])
		);

		let defaultVariable;
		if (variableBlocks) {
			[defaultVariable] = Object.keys(variableBlocks);
		}

		this.kybrdBlck = [];

		if(typeof TOOLBOX !== 'undefined' && TOOLBOX !== null) {

			if(blocks.length > 0) {
				blocks.forEach((bk)=>{
					switch (typeof bk) {
						case 'string': {
							const BLOCK = document.createElement("block");
							BLOCK.setAttribute("type", bk);
							switch (bk) {
								case 'variable_calculated': {
									BLOCK.innerHTML += '<value name="NUM1"><shadow type="variable_math_variable"><field name="NUM">1</field></shadow></value>'
									BLOCK.innerHTML += '<value name="NUM2"><shadow type="variable_math_variable"><field name="NUM">1</field></shadow></value>'
									break
								}
								case 'logic_if_variables_compare':
								case 'logic_if_else_variables_compare': {
									BLOCK.innerHTML += '<value name="NUM1"><shadow type="variable_math_logic"><field name="NUM">1</field></shadow></value>'
									BLOCK.innerHTML += '<value name="NUM2"><shadow type="variable_math_logic"><field name="NUM">1</field></shadow></value>'
									break
								}
								case 'variables_get_common':
								case 'variables_set_common':
								case 'variables_plus_common':
								case 'variables_minus_common': {
									BLOCK.innerHTML += `<field name="VAR">${defaultVariable}</field>`;
									BLOCK.innerHTML += '<value name="NUMBER"><shadow type="variable_math_variable"><field name="NUM">1</field></shadow></value>';
									break;
								}
								case 'loop_num': {
									BLOCK.innerHTML += '<value name="REPEAT"><shadow type="variable_math_loop"><field name="NUM">2</field></shadow></value>'
									break
								}
							}
							TOOLBOX.appendChild(BLOCK);
							break;
						}
						case 'object': {
							switch (bk.type) {
								case 'read': {
									const BLOCK = document.createElement("block");
									const BLOCK_NAME = 'action_read_value' + bk.index
									Blockly.Blocks[BLOCK_NAME] = {
										init: function () {
											this.jsonInit({
												"sprite": "hero",
												"message0": bk.text,
												"previousStatement": null,
												"nextStatement": null,
												"colour": ACTION_COLOR
											});
										}
									};
									Blockly.JavaScript[BLOCK_NAME] = Blockly.JavaScript['action_read_value']
									BLOCK.setAttribute('type', BLOCK_NAME);
									TOOLBOX.appendChild(BLOCK);
									break;
								}
								case 'if': {
									this.ifBlockMake(bk);
									const BLOCK = document.createElement('block');
									BLOCK.setAttribute('type', bk.name);
									TOOLBOX.appendChild(BLOCK);
									break;
								}
								case 'variable': {
									const SET_BLOCK = variableBlocks[bk.name]
									if (!Array.isArray(SET_BLOCK) || !SET_BLOCK.length) break

									const FIELD = document.createElement('field')
									FIELD.setAttribute('name', 'VAR')
									FIELD.setAttribute('id', bk.id)
									FIELD.setAttribute('variabletype', bk.variabletype)
									FIELD.innerText = bk.name

									switch (typeof SET_BLOCK[0]) {
										case 'string': {
											if (SET_BLOCK.indexOf('getter') > -1) {
												const GETTER = this.createVariableBlock(bk, 'getter', FIELD);
												TOOLBOX.appendChild(GETTER);
											}
											if (SET_BLOCK.indexOf('setter') > -1) {
												const SETTER = this.createVariableBlock(bk, 'setter', FIELD);
												TOOLBOX.appendChild(SETTER);
											}
											if (SET_BLOCK.indexOf('plus') > -1) {
												const PLUS = this.createVariableBlock(bk, 'plus', FIELD);
												TOOLBOX.appendChild(PLUS);
											}
											if (SET_BLOCK.indexOf('minus') > -1) {
												const MINUS = this.createVariableBlock(bk, 'minus', FIELD);
												TOOLBOX.appendChild(MINUS);
											}
											break;
										}
										case 'object': {
											SET_BLOCK.forEach(({ type, block, value }, i) => {
												switch (type) {
													case 'getter': {
														const GETTER = this.createVariableBlock(bk, 'getter', FIELD);
														TOOLBOX.appendChild(GETTER);
														break;
													}
													case 'setter': {
														if (block) {
															const SETTER = this.createVariableBlock(bk, 'setter', FIELD);
															TOOLBOX.appendChild(SETTER);
														} else {
															const bkName = `variables_fix_${bk.name}${i}`;
															Blockly.Blocks[bkName] = {
																init: function init () {
																	this.jsonInit({
																		message0: `${bk.name} 값을 ${value} (으)로 정하기`,
																		inputsInline: true,
																		previousStatement: null,
																		nextStatement: null,
																		colour: VARIABLE_COLOR
																	});
																}
															};
															Blockly.JavaScript[bkName] = (block, suffix) => `${suffix ? `${bk.name}.setValue(${value})` : `${bk.name} = ${value}`};\n`;
															const BLOCK = document.createElement('block');
															BLOCK.setAttribute('type', bkName);
															TOOLBOX.appendChild(BLOCK);
														}
														break;
													}
													case 'plus': {
														if (block) {
															const PLUS = this.createVariableBlock(bk, 'plus', FIELD);
															TOOLBOX.appendChild(PLUS);
														} else {
															const bkName = `variables_fix_${bk.name}${i}`;
															Blockly.Blocks[bkName] = {
																init: function init () {
																	this.jsonInit({
																		message0: `${bk.name} 값에 ${value} 만큼 더하기`,
																		inputsInline: true,
																		previousStatement: null,
																		nextStatement: null,
																		colour: VARIABLE_COLOR
																	});
																}
															};
															Blockly.JavaScript[bkName] = (block, suffix) => `${suffix ? `${bk.name}.plusValue(${value})` : `${bk.name} += ${value}`};\n`;
															const BLOCK = document.createElement('block');
															BLOCK.setAttribute('type', bkName);
															TOOLBOX.appendChild(BLOCK);
														}
														break;
													}
													case 'minus': {
														if (block) {
															const PLUS = this.createVariableBlock(bk, 'minus', FIELD);
															TOOLBOX.appendChild(PLUS);
														} else {
															const bkName = `variables_fix_${bk.name}${i}`;
															Blockly.Blocks[bkName] = {
																init: function init () {
																	this.jsonInit({
																		message0: `${bk.name} 값에 ${value} 만큼 빼기`,
																		inputsInline: true,
																		previousStatement: null,
																		nextStatement: null,
																		colour: VARIABLE_COLOR
																	});
																}
															};
															Blockly.JavaScript[bkName] = (block, suffix) => `${suffix ? `${bk.name}.minusValue(${value})` : `${bk.name} -= ${value}`};\n`;
															const BLOCK = document.createElement('block');
															BLOCK.setAttribute('type', bkName);
															TOOLBOX.appendChild(BLOCK);
														}
														break;
													}
													default:
												}
											});
											break;
										}
										default:
									}
									break;
								}
								case 'variableChange': {
									const BLOCK_OBJECT = {
										'value': bk.value,
										'sprite': 'hero',
										'message0': bk.text,
										'previousStatement': null,
										'nextStatement': null,
										'colour': ACTION_COLOR
									}
									if (bk.src && bk.src.trim()) {
										BLOCK_OBJECT.args0 = [
											{
												'type': 'field_image',
												'src': bk.src,//.replace('https://s3.ap-northeast-2.amazonaws.com', '/codmos/static/assets'),
												'width': 20,
												'height': 20
											}
										]
										BLOCK_OBJECT.message0 = '%1' + BLOCK_OBJECT.message0
									}
									Blockly.Blocks[bk.text] = {
										init: function () {
											this.jsonInit(BLOCK_OBJECT)
										}
									}
									switch (bk.action) {
										case 'getItem': {
											Blockly.JavaScript[bk.text] = (block, suffix) =>
												(
													suffix
														? `hero.getItem('${bk.res || ''}', '${JSON.stringify(block._value)}')`
														: `hero.${block.type}();`
												) + '\n'
											break
										}
										case 'putItem': {
											Blockly.JavaScript[bk.text] = (block, suffix) =>
												(
													suffix
														? `hero.putItem('${bk.res || ''}', '${JSON.stringify(block._value)}')`
														: `hero.${block.type}();`
												) + '\n'
											break
										}
										case 'changeValue': {
											Blockly.JavaScript[bk.text] = (block, suffix) =>
												(
													suffix
														? `hero.changeValue(${bk.variance || ''}, '${JSON.stringify(block._value)}')`
														: `hero.${block.type}()`
												) + ';\n'
											break
										}
										default: {
											if (bk.isGetItem === true)
												Blockly.JavaScript[bk.text] = (block, suffix) =>
													(
														suffix
															? `hero.getItem('${bk.res || ''}', '${JSON.stringify(block._value)}')`
															: `hero.${block.type}();`
													) + '\n'
											else Blockly.JavaScript[bk.text] = Blockly.JavaScript['action_change_variable']
										}
									}
									const BLOCK = document.createElement('block')
									BLOCK.setAttribute('type', bk.text)
									TOOLBOX.appendChild(BLOCK)
									break
								}
								case 'keyboard': {
									this.whenBlocks.push(bk.name);

									let message0 = `%1${bk.text}키를 `;

									if (bk.keyup) {
										message0 += '해제할 때';
										if (bk.name.indexOf('when_press_up')) {
											bk.name = bk.name.replace('when_press', 'when_press_up');
										}
									} else {
										message0 += '눌렀을 때';
									}

									const BLOCK_OBJECT = {
										type: bk.name,
										nextStatement: null,
										colour: '#ffe834',
										message0,
										args0: [
											{
												type: 'field_image',
												src: (bk.src || ''),//.replace(/https:\/\/s3.ap-northeast-2.amazonaws.com/, '/codmos/static/assets'),
												width: BLOCK_IMG_SIZE,
												height: BLOCK_IMG_SIZE
											}
										],
										value: bk.keyCode
									};
									Blockly.Blocks[bk.name] = {
										init: function init () {
											this.jsonInit(BLOCK_OBJECT);
										}
									};
									Blockly.JavaScript[bk.name] = () => '';

									this.kybrdBlck.push(bk);

									if (bk.visible !== true) break;

									const BLOCK = document.createElement('block');
									BLOCK.setAttribute('type', bk.name);
									TOOLBOX.appendChild(BLOCK);

									break;
								}
								case 'hit': {
									this.whenBlocks.push(bk.name);
									let message0 = '%1 ';
									if (bk.text) message0 += `${bk.text} `;
									message0 += '얻었을 때';
									const BLOCK_OBJECT = {
										type: bk.name,
										nextStatement: null,
										colour: '#ffe834',
										message0,
										args0: [
											{
												type: 'field_image',
												src: bk.src,
												width: BLOCK_IMG_SIZE,
												height: BLOCK_IMG_SIZE
											}
										]
									};
									Blockly.Blocks[bk.name] = {
										init: function init () {
											this.jsonInit(BLOCK_OBJECT);
										}
									};
									Blockly.JavaScript[bk.name] = () => '';

									if (bk.visible !== true) break;
									break;
								}
							}
							break;
						}
					}
				});
			}
		}

		this.whenBlocks = [];

		return TOOLBOX
	},

	/**
	 * [ Function :: updateToolbox ]
	 *
	 * @DES :: toolbox 업데이트
	 * @IP1 :: blocks {arr}
	 * @O.P ::
	 * @S.E ::
	 */
	updateToolbox(elementId, blocks, variableBlocks) {
		const TOOLBOX = this.initToolbox(elementId, blocks, variableBlocks);
		Blockly.mainWorkspace.updateToolbox(TOOLBOX);
	},

    /**
     * [Function :: setBlocklyArea]
     *
     * @DES :: 블록클리 설정하기
     * @IP1 :: elemId {str}
     * @IP2 :: isZoom {bool}
     * @O.P :: isWorkspace {bool}
     * @S.E ::
     */
    setBlocklyArea(elemId, isZoom, isWorkspace = false) {
	    if(
	    	typeof Blockly.mainWorkspace === 'undefined'
		    ||
		    Blockly.mainWorkspace == null
	    ) {
		    let blocklyArea = document.getElementById('blockly-workspace');
            let blocklyDiv = document.getElementById('blocklyDiv');
            let workspacePlayground = Blockly.inject(blocklyDiv,
			    {
				    toolbox: document.getElementById('toolbox'),
					zoom: {
						controls: true,
						wheel: true,
						startScale: .95,
						maxScale: 3,
						minScale: 0.3,
						scaleSpeed: 1.2
					},
				    trashcan: true
			    });
            this.resizeEventHandler = function(e) {
			    // Compute the absolute coordinates and dimensions of blocklyArea.
                let element = blocklyArea;
                let x = 0;
                let y = 0;
			    do {
				    x += element.offsetLeft;
				    y += element.offsetTop;
				    element = element.offsetParent;
			    } while (element);

			    // Position blocklyDiv over blocklyArea.
			    blocklyDiv.style.width = blocklyArea.offsetWidth + 'px';
			    blocklyDiv.style.height = blocklyArea.offsetHeight + 'px';
		    };
		    window.addEventListener('resize', this.resizeEventHandler, false);
            this.resizeEventHandler();
		    Blockly.svgResize(workspacePlayground);

		    if (isWorkspace) {
		    	const $blocklySvg = document.getElementsByClassName('blocklySvg');
		    	if ($blocklySvg && $blocklySvg[0]) {
                    $('.blocklySvg').css('background-color', '#454545');
                    $('.blocklyFlyoutBackground').css('fill', '#9b9b9b');
				}
			}
	    }
    },

    /**
     * [Function :: initStartBlock]
     *
     * @DES :: 시작블록 설정하기
     * @IP1 :: arrBlock {arr}
     * @O.P :: null
     * @S.E ::
     */
	initStartBlock(arrBlock, startBlock, isJb) {
		Blockly.Events.recordUndo = false;
		// [#] init blocks setting
		let initBlocks = '';
		if (typeof arrBlock !== 'undefined') arrBlock.forEach((v) => { initBlocks += `<next><block type="${v}"></block></next>`; });
		this.whenBlocks.push(this.startBlock);

		if (
			typeof startBlock === 'string'
			&& startBlock !== ''
		) {
			startBlock = Blockly.Xml.textToDom(startBlock);
			if (startBlock.childNodes.length) {
				const START_X_WEIGHT = this.isShowTxbx ? 30 : 100;
				const START_Y_WEIGHT = this.isShowTxbx ? 30 : 50;

				const START_X = this.isShowTxbx ? startBlock.childNodes[0].getAttribute('x') : 0;
				const START_Y = startBlock.childNodes[0].getAttribute('y');
				const CHILD_NODES = startBlock.childNodes;
				for (let i = 0; i < CHILD_NODES.length; i++) {
					const CHILD_NODE = CHILD_NODES[i];
					const TYPE = CHILD_NODE.getAttribute('type');
					if (TYPE && !TYPE.indexOf('when')) {
						if (TYPE === 'en_when_press_start_button') {
							CHILD_NODE.setAttribute('type', this.startBlock);
							Blockly.Blocks[this.startBlock] = {
								init: function init () {
									this.jsonInit({
										type: this.startBlock,
										sprite: 'hero',
										message0: 'when run',
										nextStatement: null,
										colour: '#ffe834',
										tooltip: '',
										helpUrl: ''
									});
								}
							};
						}
						CHILD_NODE.setAttribute('deletable', 'false');
						CHILD_NODE.setAttribute('movable', 'true');
						const x = CHILD_NODE.getAttribute('x') - START_X + START_X_WEIGHT;
						const y = CHILD_NODE.getAttribute('y') - START_Y + START_Y_WEIGHT;
						CHILD_NODE.setAttribute('x', x);
						CHILD_NODE.setAttribute('y', y);
						CHILD_NODE.setAttribute('color', 'black');
						this.whenBlocks.push(CHILD_NODE.getAttribute('type'));
					}
				}
			} else startBlock = undefined;
		}

		this.whenBlocks = this.whenBlocks.reduce((a, b) => { if (a.indexOf(b) === -1 && !b.indexOf('when')) a.push(b); return a; }, []);

		// [#] start block setting
		const TEXT_BLOCK = typeof startBlock === 'object'
			? startBlock.outerHTML
			: '<xml xmlns="http://www.w3.org/1999/xhtml">'
			+ `<block type="${this.startBlock}" deletable="false" movable="true" x="30" y="30" color="black">`
			+ initBlocks
			+ '</block>'
			+ '</xml>';

		// [#] Blockly.mainWorkspace.clear & Blockly.Xml.domToWorkspace
		Blockly.mainWorkspace.clear();
		Blockly.Xml.domToWorkspace(Blockly.Xml.textToDom(TEXT_BLOCK), Blockly.mainWorkspace);

		// [#] 'when_press_start_button' 색상변경
		if (!isJb) {
			this.whenBlocks.forEach((e) => {
				this.changeBlockColor(e, '#000');
			});
		}

		if (this.resizeEventHandler) {
			this.resizeEventHandler();
			Blockly.svgResize(Blockly.mainWorkspace);
		}
		Blockly.Events.recordUndo = true;
    },

	/**
	 * [Function :: getBlockByType]
	 *
	 * @DES :: 'type'을 통해서 'block'을 반환받는 함수
	 * @IP1 :: type {str}
	 * @O.P ::
	 * @S.E ::
	 */
	getBlockByType(type){
		return Blockly.mainWorkspace.getAllBlocks().filter((v)=>{
			if(v.type == type) { return v; }
		})[0];
	},
	getBlockByType2(type){
		return Blockly.mainWorkspace.getAllBlocks().filter((v) => v.type === type);
	},

	/**
	 * [ Function :: getBlockCount ]
	 *
	 * @DES :: 시작블록에 연결된 블록 갯수 얻기
	 * @IP1 :: type {str}
	 * @O.P :: count {num}
	 * @S.E ::
	 */
	getBlockCount(type) {
		let startBlock = this.getBlockByType(type);
		return this.getNextBlockCount(startBlock.getNextBlock());
	},
	getBlockCount2() {
		return this.whenBlocks.reduce((a, b) => a + this.getBlockByType2(b).reduce((a2, b2) => a2 + this.getNextBlockCount(b2), 0), 0);
	},

	/**
	 * [ Function:: getChildBlockCount ]
	 *
	 * @DES :: 내부에 모든 블록 얻기
	 * @IP1 :: block {obj}
	 * @O.P :: count {num}
	 * @S.E ::
	 */
	getChildBlockCount (block) {
		if(
			(block.getNextBlock() === null && block.getChildren().length === 1)
		) {
			let childBlock = block.getChildren()[0];
			return this.getNextBlockCount(childBlock);
		}
		else if (block.getChildren().length > 1) {
			// let childBlock = block.getChildren()[0];
			// if(childBlock === block.getNextBlock()) childBlock = block.getChildren()[1]
			// return this.getNextBlockCount(childBlock);
			let count = 0;
			let child = block.getChildren()
			let next = block.getNextBlock()
			if (child.length > 0)
                child.forEach(e => {
                    if (e !== next)
                        count += this.getNextBlockCount(e)
                })
			return count
		}
		else {
			return 0;
		}
	},

	/**
	 * [ Function :: getNextBlockCount ]
	 *
	 * @DES :: 다음 모든 블록 얻기 ( 중간에 자식이 있다면 자식도 포함 )
	 * @IP1 :: block {obj}
	 * @O.P :: count {num}
	 * @S.E ::
	 */
	getNextBlockCount (block) {
		if (typeof block !== 'undefined' && block !== null) {
			let count = 0
			do {
				const BLOCK_TYPE = block.type.replace(/[0-9]/g, '')

				switch (BLOCK_TYPE) {
					case this.startBlock:
					case 'variable_math_loop':
					case 'variable_math_logic':
					case 'variable_math_variable': {
						break
					}
					default: {
						if (!BLOCK_TYPE.indexOf('when_')) break
						// 자신
						count += 1

						// 자식
						count += this.getChildBlockCount(block)
					}
				}

				// /*[T]*/ console.log(block.type);

				// 다음
				block = block.getNextBlock()

				// console.log('getNextBlockCount step :: ', count);
			} while (block != null)
			return count
		} else return 0
	},

    /**
     * [Function :: createInterpreter]
     *
     * @DES :: 인터프리터 객체를 생성하는 함수
     * @IP1 :: controller {obj}
     * @IP2 :: cbRun {func}
     * @O.P ::
     * @S.E ::
     */
    createInterpreter(controller, cbRun, cbStep) {
		const ARR_ASYNC_METHOD = [
			'checkUnderType', 'checkFrontType', 'checkLeftType', 'checkRightType', 'checkBackType',
			'checkUnderRes', 'checkFrontRes', 'checkLeftRes', 'checkRightRes', 'checkBackRes',
			'checkFrontPathColor', 'checkUnderResource', 'checkFrontResource', 'checkNorthResource',
			'checkEastResource', 'checkSouthResource', 'checkWestResource'
		];

		const hero = controller.world[this.heroId];

		// [#] interpreter scope 처리
		for (const key in hero) {
			// [#] TODO 'hero'가 가지고 있는 함수들 중 'sync와 async'를 분리하는 값이 있어야 합니다.
			const value = hero[key];
			if (typeof value === 'function') {
				hero[key] = {
					$isAsync: !ARR_ASYNC_METHOD.includes(key),
					function: value
				};
			}
		}

		let SCOPE = {
			hero: controller.world[this.heroId]
		};
		
		if (controller.isVariable === true) {
			this.variable = controller.getAllVariable() || this.variable

			Object.keys(this.variable).forEach(e => {
				for (const e2 in this.variable[e])
					if (typeof this.variable[e][e2] === 'function') this.variable[e][e2] = {
						$isAsync: false,
						function: this.variable[e][e2]
					}
			})

			Object.assign(SCOPE, this.variable)
		}

	    // [#] interpreter api 처리
	    const API = {
		    // [#]
		    'highlight' : function (id) {
			    Blockly.mainWorkspace.highlightBlock(id);
			},
			alert
	    };

	    this.interpreter = new Interpreter( null/*init처리안됨*/ , SCOPE, API );

	    // [#] interpreter end callback
	    if(typeof cbRun !== 'undefined') this.interpreter.cbRun = cbRun;

	    // [#] interpreter step callback
	    if(typeof cbRun !== 'undefined') this.interpreter.cbStep = cbStep;

	    // [#] interpreter error callback
		this.interpreter.cbError = function (e) { console.log(e); };
		
		controller.interpreter = this.interpreter
    },

	/**
	 * [Function :: initInterpreter]
	 *
	 * @DES :: 인터프리터를 초기화하는 함수
	 * @IP1 :: controller {obj}
	 * @O.P ::
	 * @S.E ::
	 */
	initInterpreterByBlock(name) {
		if(typeof this.interpreter !== 'undefined') {
			// Blockly.JavaScript.STATEMENT_PREFIX = 'highlight(%1);';
			// Blockly.JavaScript.addReservedWords('highlight');
			// const BLOCK = this.getBlockByType(name);
			// const CODE = Blockly.JavaScript.blockToCode(BLOCK);

			const CODE = this.getBlockCode(name, 'highlight(%1);');
            // /*[T]*/ console.log(CODE);
			this.interpreter.init(CODE);
		}
		else console.log('interpreter 없음 => 확인필요');
	},

    /**
     * [Function :: runInterpreter]
     *
     * @DES :: 인터프리터 실행시키기
     * @IP1 ::
     * @O.P ::
     * @S.E ::
     */
    runInterpreter() {
	    if(typeof this.interpreter !== 'undefined') {
		    this.interpreter.run();
	    }
	    else console.log('interpreter 없음 => 확인필요');
    },

	/**
	 * [ Function :: getBlockCode ]
	 *
	 * @DES :: 블록 코드 얻기
	 * @IP1 :: block {str}
	 * @IP2 :: prefix {str}
	 * @O.P :: {str}
	 * @S.E ::
	 */
	getBlockCode(block, prefix) {
		if(typeof prefix !== 'undefined') Blockly.JavaScript.STATEMENT_PREFIX = prefix;
		// Blockly.JavaScript.addReservedWords('highlight');

		const BLOCK = this.getBlockByType(block);
		return Blockly.JavaScript.blockToCode(BLOCK);
	},

	/**
	 * [ Function :: loadTextBlock ]
	 *
	 * @DES :: 텍스트 블록을 워크스페이스에 로드하기
	 * @IP1 :: workspace {obj}
	 * @IP2 :: txtBlock {str}
	 * @O.P ::
	 * @S.E ::
	 */
	loadTextBlock (workspace, txtBlock, isJb) {
        if (workspace) {
        	if (typeof this.loadBlockIdle !== 'undefined') {
        		window.clearInterval(this.loadBlockIdle);
                this.loadBlockIdle = undefined;
			}

            workspace.clear();
            Blockly.Xml.domToWorkspace(workspace, Blockly.Xml.textToDom(txtBlock));
			// [#] 'when_press_start_button' 색상변경
			if (!isJb) {
				this.changeBlockColor('when_press_start_button', '#000');
			}
        } else {
        	// # Blockly Workspace Fallback
        	this.loadBlockIdle = window.setInterval(() => {
        		console.error('Blockly Reload....');
                this.loadTextBlock(Blockly.mainWorkspace, txtBlock);
			}, 1000);
		}
	},

	/**
	 * [ Function :: changeStartBlockColor ]
	 *
	 * @DES :: 블록 색상 바꾸기
	 * @IP1 :: type {str}
	 * @IP2 :: color {str}
	 * @O.P ::
	 * @S.E ::
	 */
	changeBlockColor(type, color) {
		const START_BLOCK = this.getBlockByType(type);
		if (START_BLOCK && START_BLOCK.svgGroup_) {
			const subNodeGroups = START_BLOCK.svgGroup_.childNodes;
			const TEXT_PATH = subNodeGroups[subNodeGroups.length - 1];
			TEXT_PATH.setAttribute("style", "fill:" + color + ";");
		}
	},

	getIsIn (target, block) {
		let bool = false;

		let targetBlock;

		switch (typeof target) {
			case 'string': {
				targetBlock = Blockly.mainWorkspace.getAllBlocks().find(e => e.type === target);
				break;
			}
			case 'object': {
				targetBlock = target;
				break;
			}
			default:
		}

		if (targetBlock) {
			const func = () => {
				const next = targetBlock.getNextBlock();
				if (next) {
					if (next.type === block) bool = true;
					else {
						const children = next.getChildren();
						if (
							children.some(
								e => e.type === block || this.getIsIn(e, block)
							)
						) {
							bool = true;
						} else {
							targetBlock = next;
							func();
						}
					}
				}
			};

			func();
		}

		return bool;
	},
	getInCount (target, block) {
		const targetBlock = Blockly.mainWorkspace.getAllBlocks().find(e => e.type === target);

		const blocks = new Set();

		if (targetBlock) {
			const children = targetBlock.getChildren();

			const func = (arr) => {
				if (arr && arr.length) {
					arr.forEach((e) => {
						blocks.add(e);
						func(e.getChildren());
					});
					func();
				}
			};

			func(children);
		}

		return Array.from(blocks).reduce((a, b) => b.type === block ? ++a : a, 0);
	}

}



// WEBPACK FOOTER //
// ./src/assets/js/codmos/BlocklyManager.js